import { AqElement, cart, debounce, emitCartUpdate, qs, toast } from '@aq/core';

/* Cart page: quantity, remove, note and discount update in place and re-render the page body. */
class AqCartPage extends AqElement {
  init() {
    this.sectionId = this.dataset.sectionId;
    this.listen(this, 'click', (event) => this.#onClick(event));
    this.listen(
      this,
      'input',
      debounce((event) => event.target.matches('[data-cart-note]') && this.#note(event.target.value), 600),
    );
  }

  async #onClick(event) {
    const line = event.target.closest('[data-key]');
    const step = event.target.closest('[data-qty-change]');
    const remove = event.target.closest('[data-remove]');

    if (line && (step || remove)) {
      const current = Number(qs('.aq-qty span', line).textContent);
      const quantity = remove ? 0 : Math.max(0, current + Number(step.dataset.qtyChange));
      await this.#run(() => cart.change(line.dataset.key, quantity, this.sectionId));
      return;
    }
    if (event.target.closest('[data-discount-apply]')) {
      const input = qs('[data-discount-input]', this);
      if (input?.value.trim()) await this.#run(() => cart.update({ discount: input.value.trim(), sections: this.sectionId }));
    }
  }

  async #note(note) {
    try {
      await cart.update({ note });
    } catch (error) {
      toast(error.message);
    }
  }

  async #run(action) {
    this.setAttribute('aria-busy', 'true');
    try {
      const data = await action();
      const html = data.sections?.[this.sectionId];
      if (html) {
        const next = qs('[data-cart-body]', new DOMParser().parseFromString(html, 'text/html'));
        if (next) qs('[data-cart-body]', this).innerHTML = next.innerHTML;
      }
      emitCartUpdate(data);
    } catch (error) {
      toast(error.message);
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('aq-cart-page')) customElements.define('aq-cart-page', AqCartPage);
